import React, { FC, useState } from 'react';
import { StandardPostDetailed } from 'app/types/StandardPostDetailed';
import { BenchmarksForPosts } from 'app/types/BenchmarksForPosts';
import PostExpanded from './PostExpanded';
import PostCollapsed from './PostCollapsed';
import {
  getPostBenchmarkValue,
  getPostMaxValue,
  getPostMetricValue,
} from '../utils/postPerformance';
import { PostCollapsedLayoutVariant } from 'app/modules/insights/modules/postsPerformance/components/postCollapsed/PostCollapsedLayout';
import { MetricProperty } from 'app/modules/insights/types/MetricProperty';
import { getSocialMediaPostOpener } from 'app/modules/insights/utils/getSocialMediaPostOpener';

type Props = {
  pageType: number;
  post: StandardPostDetailed;
  metric: MetricProperty;
  benchmarks: BenchmarksForPosts;
  index: number;
  collapsedLayoutVariant?: PostCollapsedLayoutVariant;
};

const SinglePost: FC<Props> = (props) => {
  const [expanded, setExpanded] = useState(false);

  const benchmarkValue = getPostBenchmarkValue(
    props.benchmarks[`type_${props.post.type}`],
    props.metric.key,
  );
  const metricValue = getPostMetricValue(props.post.metrics[props.metric.key]);

  const performanceValues = {
    benchmark: benchmarkValue ?? 0,
    metric: metricValue ?? 0,
    max: getPostMaxValue(benchmarkValue, metricValue) ?? 0,
  };

  return expanded ? (
    <PostExpanded
      {...props}
      performanceValues={performanceValues}
      toggleExpanded={() => setExpanded((prevState) => !prevState)}
      expanded={expanded}
      seeOnClickHandler={getSocialMediaPostOpener(props.pageType, props.post)}
    />
  ) : (
    <PostCollapsed
      {...props}
      layoutVariant={props.collapsedLayoutVariant}
      performanceValues={performanceValues}
      toggleExpanded={() => setExpanded((prevState) => !prevState)}
      expanded={expanded}
      seeOnClickHandler={getSocialMediaPostOpener(props.pageType, props.post)}
    />
  );
};

export default SinglePost;
